import { type SupportedActivityEvent } from '../activities'

interface ActivitiesEn {
  descriptions: Record<SupportedActivityEvent, string>
}

export const activitiesEn: ActivitiesEn = {
  descriptions: {
    'billing:invoice-payment-failed': 'subscription payment failed',
    'billing:invoice-payment-succeeded': 'collected subscription payment',
    'billing:subscription-cancelled': 'cancelled subscription',
    'billing:subscription-created': 'created new subscription',
    'billing:subscription-tier-updated': 'updated subscription tier',
    'checkout:olo-settings-updated': 'updated OLO settings',
    'customer:customer-list-imported': 'imported customer list',
    'delivery:delivery-settings-updated': 'updated delivery settings',
    'domain:dns-type-changed': 'changed DNS type',
    'domain:record-added': 'added domain record',
    'domain:record-changed': 'changed domain record',
    'domain:record-deleted': 'deleted domain record',
    'domain:remote-dns-vendor-changed': 'changed remote DNS vendor',
    'domain:requested-domain-verification': 'requested domain verification',
    'domain:template-added': 'added domain template',
    'domain:template-changed': 'changed domain template',
    'domain:template-deleted': 'deleted domain template',
    'google:brand-gbp-grant-created': 'created brand GBP grant',
    'google:location-gbp-invitation-accepted':
      'accepted location GBP invitation',
    'google:location-gbp-invitation-sent': 'sent location GBP invitation',
    'launch:domain-information-submitted': 'submitted domain information',
    'launch:onboarding-step-skipped': 'skipped onboarding step',
    'launch:pre-consultation-info-submitted':
      'submitted pre-consultation information',
    'partner:cuisines-updated': 'updated brand cuisines',
    'partner:location-address-changed': 'updated location address',
    'partner:location-status-updated': 'updated location status',
    'partner:online-hours-buffer-updated': 'updated Online Hours buffer',
    'partner:online-hours-custom-updated': 'updated custom Online Hours',
    'partner:online-hours-mapping-changed': 'changed Online Hours mapping',
    'partner:owner-fee-settings-updated': 'updated owner fee settings',
    'partner:processing-settings-updated': 'updated processing settings',
    'partner:special-hours-created': 'created Special Hours',
    'partner:special-hours-deleted': 'deleted Special Hours',
    'partner:special-hours-updated': 'updated Special Hours',
    'partner:store-hours-updated': 'updated Store Hours',
    'registrar:domain-registered': 'registered domain',
    'registrar:domain-transfer-started': 'started domain transfer',
    'virtualcards:card-created': 'created virtual card',
    'virtualcards:card-details-viewed': 'viewed card details',
    'virtualcards:card-state-changed': 'changed card state',
    'virtualcards:card-transaction-received': 'received transaction',
  },
}
